const isPromoActive = new Date('2022-12-01T00:00:00').getTime() > new Date().getTime();

const getFunnelUrl = () => {
	return isPromoActive ? 'https://lp.connect.pr/bf22' : '/cobertura';
};

export { getFunnelUrl };
